module.exports = __webpack_public_path__ + "img/icon-server.16f6d947.svg";